module.exports = __webpack_public_path__ + "static/media/om.61e54dd6.svg";